import ActiveSideMenuAccordionContextProvider from '../../../store/context/activeSideMenuAccordionContext';
import { hasPermission } from '../../../utils/HelperFunctions';
import TogglerNavLink from './TogglerNavLink';
import {
  createIcon,
  listIcon,
  Sales,
  permissionsIcon,
  stepsIcon,
  dashboard,
  vehicleMakeIcon,
  bodyTypeIcon,
  fuelTypeIcon,
  locationIcon,
  transmissionsIcon,
  colorsIcon,
  cityIcon,
  warrantyIcon
} from '../../../config/variables';
import { useTranslation } from 'react-i18next';
import { IMenuLinks, ISingleMenuLinks, ITogglerNavLinkGroup } from '../../../types/Interfaces';
import { useMemo, useState } from 'react';
import SingleNavLinks from './SingleNavLink';
import { IVehicleMake } from '../../../modules/vehicleMakes/types/interfaces';
import { generalGet } from '../../../API/api';
import { useQuery } from '@tanstack/react-query';
import NavLinksGroup from './NavLinksGroup';

const SideMenuLinks = ({ isMouseOver }: { isMouseOver: boolean }) => {
  const { t, i18n } = useTranslation();

  // const { authData } = useSelector((store: any) => store);

  // console.log(authData, "authData")

  // const canViewServiceProviders = () => {
  //   return (
  //     (hasPermission(['service_providers.edit']) || hasPermission(['service_providers.crud'])) && !authData?.userData.service_provider_id && !authData?.userData.distributor_id
  //   );
  // };

  // const canViewDistributors = () => {
  //   return (hasPermission(['distributors.edit']) || hasPermission(['distributors.edit'])) && !authData?.userData.service_provider_id && !authData?.userData.distributor_id;
  // };

  // const serviceProviderLinks = {
  //   header: t('links.services'),
  //   baseRoute: '/services',
  //   headerIcon: [serviceIcon],
  //   keyName: 'serviceProviderLinks',
  //   nestedLinks: [
  //     hasPermission(['service_providers.show']) && { label: t('links.services'), link: '/services', icon: [listIcon] },
  //     hasPermission(['service_providers.crud']) && { label: t('links.create_service'), link: '/services/create-service', icon: [createIcon] }
  //   ]
  // };
  // const quotationsLinks = {
  //   header: t('links.quotations'),
  //   baseRoute: '/quotations',
  //   headerIcon: [serviceIcon],
  //   keyName: 'quotationsLinks',
  //   nestedLinks: [
  //     // hasPermission(['quotations.show']) && { label: t('links.services'), link: '/services', icon: [listIcon] },
  //     { label: t('links.quotations'), link: '/quotations', icon: [listIcon] },
  //     // hasPermission(['quotations.crud']) && { label: t('links.create_service'), link: '/services/create-service', icon: [createIcon] }
  //     { label: t('create_quotation'), link: '/quotations/create-quotation', icon: [createIcon] }
  //   ]
  // };

  // const pagesLinks = {
  //   header: t('links.pages'),
  //   baseRoute: '/pages',
  //   headerIcon: [listIcon],
  //   nestedLinks: {
  //     label: t('links.pages'),
  //     link: '/pages',
  //     icon: [listIcon]
  //   }
  // };

  const { data, isSuccess } = useQuery({
    queryKey: ['makes', i18n],
    queryFn: () => generalGet('admin/makes'),
    refetchOnWindowFocus: false,
    enabled: hasPermission(['makes.show'])
  });

  const vehicleMakes: IVehicleMake[] = useMemo(() => {
    const reqData = data?.data.data;
    if (isSuccess) {
      return reqData;
    }
    return [];
  }, [isSuccess, data]);

  function filterValidNested(links: any) {
    return links.filter(
      (
        ele: any
      ): ele is {
        label: string;
        link: string;
        icon: JSX.Element[];
      } => ele !== false
    );
  }

  const bodyTypesLinks = {
    header: t('links.body_types'),
    baseRoute: '/body-types',
    headerIcon: [bodyTypeIcon],
    keyName: 'bodyTypesLinks',
    nestedLinks: filterValidNested([
      hasPermission(['body_types.show']) && { label: t('links.body_types'), link: '/body-types', icon: [listIcon] },
      hasPermission(['body_types.show']) && { label: t('create_body_type'), link: '/body-types/create-body-type', icon: [createIcon] }
    ])
  };

  const accessoriesLinks = {
    header: t('links.accessories'),
    baseRoute: '/accessories',
    headerIcon: [bodyTypeIcon],
    keyName: 'accessoriesLinks',
    nestedLinks: filterValidNested([
      hasPermission(['accessories.show']) && { label: t('links.accessories'), link: '/accessories', icon: [listIcon] },
      hasPermission(['accessories.edit']) && { label: t('create_accessory'), link: '/accessories/create-accessory', icon: [createIcon] }
    ])
  };
  const citiesLinks = {
    header: t('links.cities'),
    baseRoute: '/cities',
    headerIcon: [cityIcon],
    keyName: 'citiesLinks',
    nestedLinks: [
      { label: t('links.cities'), link: '/cities', icon: [listIcon] },
      { label: t('create_city'), link: '/cities/create-city', icon: [createIcon] }
    ]
  };

  const deliveryOptionsLinks = {
    header: t('links.delivery_options'),
    baseRoute: '/delivery-options',
    headerIcon: [listIcon],
    keyName: 'deliveryOptionsLinks',
    nestedLinks: [
      hasPermission(['locations.edit']) && { label: t('links.delivery_options'), link: '/delivery-options', icon: [listIcon] },
      hasPermission(['locations.edit']) && { label: t('create_delivery_option'), link: '/delivery-options/create-delivery-option', icon: [createIcon] }
    ]
  };

  const vehicleMakesLinks: IMenuLinks = {
    header: t('links.vehicle_makes'),
    baseRoute: '/vehicle-makes',
    headerIcon: [vehicleMakeIcon],
    keyName: 'vehicleMakesLinks',
    nestedLinks: filterValidNested([
      hasPermission(['makes.show']) && { label: t('links.vehicle_makes'), link: '/vehicle-makes', icon: [listIcon] },
      hasPermission(['makes.edit']) && { label: t('create_vehicle_make'), link: '/vehicle-makes/create-vehicle-make', icon: [createIcon] }
    ])
  };

  const vehicleModelsLinks = {
    header: t('links.models'),
    baseRoute: '/vehicle-models',
    headerIcon: [vehicleMakeIcon],
    keyName: 'vehicleModelsLinks',
    nestedLinks:
      vehicleMakes?.length == 1
        ? {
            label: vehicleMakes[0]?.name,
            link: `/vehicle-models/${vehicleMakes[0]?.id}`,
            icon: [listIcon]
          }
        : vehicleMakes?.map((item) => ({ label: item.name, link: `/vehicle-models/${item?.id}`, icon: [listIcon] }))
  };

  const transmissionLinks = {
    header: t('links.transmissions'),
    baseRoute: '/transmission',
    headerIcon: [transmissionsIcon],
    keyName: 'transmissionLinks',
    nestedLinks: filterValidNested([
      hasPermission(['transmissions.show']) && { label: t('links.transmissions'), link: '/transmissions', icon: [transmissionsIcon] },
      hasPermission(['transmissions.edit']) && { label: t('create_transmission'), link: '/transmissions/create-transmission', icon: [createIcon] }
    ])
  };

  const vehiclesLinks = {
    header: t('links.vehicles'),
    baseRoute: '/vehicles',
    headerIcon: [bodyTypeIcon],
    keyName: 'vehiclesLinks',
    nestedLinks: { label: t('links.vehicles'), link: '/vehicles', icon: [listIcon] }
  };

  const ordersLinks = {
    header: t('links.orders'),
    baseRoute: '/orders',
    headerIcon: [bodyTypeIcon],
    keyName: 'ordersLinks',
    nestedLinks: [
      { label: t('links.orders'), link: '/orders', icon: [listIcon] },
      hasPermission(['orders.edit']) && { label: t('create_order'), link: '/orders/create-order', icon: [createIcon] }
    ]
  };

  const fuelTypesLinks = {
    header: t('links.fuel_types'),
    baseRoute: '/fuel-types',
    headerIcon: [fuelTypeIcon],
    keyName: 'fuelTypesLinks',
    nestedLinks: filterValidNested([
      hasPermission(['fuel_types.show']) && { label: t('links.fuel_types'), link: '/fuel-types', icon: [listIcon] },
      hasPermission(['fuel_types.edit']) && { label: t('create_fuel_type'), link: '/fuel-types/create-fuel-type', icon: [createIcon] }
    ])
  };

  const leadsLinks = {
    header: t('links.leads'),
    baseRoute: '/leads',
    headerIcon: [Sales],
    keyName: 'leadsLinks',
    nestedLinks: filterValidNested([
      hasPermission(['leeds.show']) && { label: t('links.leads'), link: '/leads', icon: [listIcon] },
      hasPermission(['leeds.show']) && { label: t('create_lead'), link: '/leads/create-lead', icon: [createIcon] }
    ])
  };

  const specificationGroupsLinks = {
    header: t('links.specification_groups'),
    baseRoute: '/specification-groups',
    headerIcon: [listIcon],
    keyName: 'specificationGroupsLinks',
    nestedLinks: filterValidNested([
      hasPermission(['specs_groups.show']) && { label: t('links.specification_groups'), link: '/specification-groups', icon: [listIcon] },
      hasPermission(['specs_groups.edit']) && { label: t('create_specification_group'), link: '/specification-groups/create-group', icon: [createIcon] }
    ])
  };

  const locationsLinks = {
    header: t('links.locations'),
    baseRoute: '/locations',
    headerIcon: [locationIcon],
    keyName: 'locationsLinks',
    nestedLinks: [
      { label: t('links.locations'), link: '/locations', icon: [listIcon] },
      { label: t('create_location'), link: '/locations/create-location', icon: [createIcon] }
    ]
  };
  const exteriorColorsLinks = {
    header: t('links.exterior_colors'),
    baseRoute: '/exterior-colors',
    headerIcon: [colorsIcon],
    keyName: 'exteriorColorsLinks',
    nestedLinks: filterValidNested([
      hasPermission(['colors.show']) && { label: t('links.exterior_colors'), link: '/exterior-colors', icon: [listIcon] },
      hasPermission(['colors.edit']) && { label: t('create_exterior_color'), link: '/exterior-colors/create-exterior-color', icon: [createIcon] }
    ])
  };
  const interiorColorsLinks = {
    header: t('links.interior_colors'),
    baseRoute: '/interior-colors',
    headerIcon: [colorsIcon],
    keyName: 'interiorColorsLinks',
    nestedLinks: filterValidNested([
      hasPermission(['colors.show']) && { label: t('links.interior_colors'), link: '/interior-colors', icon: [listIcon] },
      hasPermission(['colors.edit']) && { label: t('create_interior_color'), link: '/interior-colors/create-interior-color', icon: [createIcon] }
    ])
  };

  const generalFormsLinks = {
    header: t('links.general_forms'),
    baseRoute: '/general-forms',
    headerIcon: [listIcon],
    keyName: 'generalFormsLinks',
    nestedLinks: [
      { label: t('links.offers_forms'), link: '/general-forms/offers', icon: [listIcon] },
      { label: t('links.contact-us_forms'), link: '/general-forms/contact-us', icon: [listIcon] },
      { label: t('links.news-letter_forms'), link: '/general-forms/news-letter', icon: [listIcon] },
      { label: t('links.quote_forms'), link: '/general-forms/quote', icon: [listIcon] }
    ]
  };

  // const productLinks = {
  //   header: t('links.products'),
  //   baseRoute: '/products',
  //   headerIcon: [productIcon],
  //   keyName: 'productLinks',
  //   nestedLinks: [
  //     hasPermission(['products.show']) && { label: t('links.products'), link: '/products', icon: [listIcon] },
  //     hasPermission(['products.edit']) && { label: t('links.create_product'), link: '/products/create-product', icon: [createIcon] }
  //   ]
  // };

  // const distributorsLinks = {
  //   header: t('links.distributors'),
  //   baseRoute: '/distributors',
  //   headerIcon: [distIcon],
  //   keyName: 'distributorsLinks',
  //   nestedLinks: [
  //     hasPermission(['distributors.show']) && { label: t('links.distributors'), link: '/distributors', icon: [listIcon] },
  //     hasPermission(['distributors.edit']) && { label: t('links.create_distributor'), link: '/distributors/create-distributor', icon: [createIcon] }
  //   ]
  // };

  // const salesLinks = {
  //   header: t('sales'),
  //   baseRoute: '/sales',
  //   headerIcon: [Sales],
  //   keyName: 'salesLinks',
  //   nestedLinks: [
  //     hasPermission(['users.show']) && { label: t('sales'), link: '/sales', icon: [listIcon] },
  //     hasPermission(['users.edit']) && { label: t('create_sales'), link: '/sales/create-sales-executive', icon: [createIcon] }
  //   ]
  // };
  // const findDealLinks = {
  //   header: t('links.find_deal'),
  //   baseRoute: '/applications/create/find-deal',
  //   headerIcon: [Deal],
  //   keyName: 'findDealLinks',
  //   nestedLinks: { link: '/applications/create/find-deal', label: t('find_deal') }
  // };

  // const applicationsLinks = {
  //   header: t('links.applications'),
  //   baseRoute: '/applications',
  //   headerIcon: [applicationsIcon],
  //   keyName: 'applicationsLinks',
  //   nestedLinks: { link: '/applications', label: t('links.applications') }
  // };

  const rolesLinks = {
    header: t('rolesAndPermissions'),
    baseRoute: '/roles',
    headerIcon: [permissionsIcon],
    keyName: 'rolesLinks',
    nestedLinks: filterValidNested([
      hasPermission(['roles.show']) && { label: t('roles'), link: '/roles', icon: [listIcon] },
      hasPermission(['roles.edit']) && { label: t('createRole'), link: '/roles/create-role', icon: [createIcon] }
    ])
  };

  const dashboardLinks: ISingleMenuLinks = {
    header: hasPermission(['dashboard.show']) ? t('dashboard') : t('home'),
    baseRoute: '/dashboard',
    headerIcon: [dashboard],
    keyName: 'dashboardLinks',
    nestedLinks: { link: '/dashboard', label: t('dashboard') }
  };

  const adminsLinks = {
    header: t('links.admins'),
    baseRoute: '/admins',
    headerIcon: [Sales],
    keyName: 'adminsLinks',
    nestedLinks: filterValidNested([
      hasPermission(['admins.show']) && { label: t('links.admins'), link: '/admins', icon: [listIcon] },
      hasPermission(['admins.edit']) && { label: t('create_admin'), link: '/admins/create-admin', icon: [createIcon] }
    ])
  };

  const orderStepsLinks = {
    header: t('order_steps_creation'),
    baseRoute: '/order-steps',
    headerIcon: [stepsIcon],
    keyName: 'orderStepsLinks',
    nestedLinks: filterValidNested([
      hasPermission(['order_steps.show']) && { label: t('order_steps'), link: '/order-steps', icon: [listIcon] },
      hasPermission(['order_steps.edit']) && { label: t('create_order_step'), link: '/order-steps/create-order-step', icon: [createIcon] }
    ])
  };

  const termsAndConditionsLinks = {
    header: t('terms-and-conditions'),
    baseRoute: '/terms-and-conditions',
    headerIcon: [listIcon],
    keyName: 'termsAndConditionsLinks',
    nestedLinks: [
      { label: t('terms-and-conditions'), link: '/terms-and-conditions', icon: [listIcon] },
      { label: t('create_terms_and_conditions'), link: '/terms-and-conditions/create-terms-and-conditions', icon: [createIcon] }
    ]
  };

  const faqs = {
    header: t('faqs'),
    baseRoute: '/faqs',
    headerIcon: [listIcon],
    keyName: 'faqs',
    nestedLinks: [
      { label: t('faqs'), link: '/faqs', icon: [listIcon] },
      { label: t('create_faq'), link: '/faqs/create-faq', icon: [createIcon] }
    ]
  };
  const financingApplicationsLinks = {
    header: t('links.financing_applications'),
    baseRoute: '/financing-applications',
    headerIcon: [listIcon],
    keyName: 'financingApplications',
    nestedLinks: { label: t('links.financing_applications'), link: '/financing-applications', icon: [listIcon] }
  };

  const warrantiesLinks = {
    header: t('links.warranties'),
    baseRoute: '/warranties',
    headerIcon: [warrantyIcon],
    keyName: 'warrantiesLinks',
    nestedLinks: [
      { label: t('links.warranties'), link: '/warranties', icon: [listIcon] },
      { label: t('create_warranty'), link: '/warranties/create-warranty', icon: [createIcon] }
    ]
  };

  const menuGroups: ITogglerNavLinkGroup[] = [
    {
      name: t('vehicles'),
      icon: [bodyTypeIcon],
      keyName: 'vehiclesGroupLinks',
      links: [
        hasPermission(['makes.show', 'makes.edit']) && vehicleMakesLinks,
        hasPermission(['models.show', 'models.edit']) && vehicleModelsLinks,
        hasPermission(['vehicles.show']) && vehiclesLinks,
        hasPermission(['body_types.show']) && bodyTypesLinks,
        hasPermission(['fuel_types.show', 'fuel_types.edit']) && fuelTypesLinks,
        hasPermission(['transmissions.show', 'transmissions.edit']) && transmissionLinks,
        hasPermission(['accessories.show', 'accessories.edit']) && accessoriesLinks,
        hasPermission(['accessories.show', 'accessories.edit']) && warrantiesLinks,
        hasPermission(['specs_groups.show', 'specs_groups.edit']) && specificationGroupsLinks,
        hasPermission(['colors.show', 'colors.edit']) && exteriorColorsLinks,
        hasPermission(['colors.show', 'colors.edit']) && interiorColorsLinks
      ].filter(Boolean) as (IMenuLinks | ISingleMenuLinks)[]
    },
    // {
    //   name: t('links.leads'),
    //   icon: [Sales],
    //   keyName: 'leadsGroupLinks',
    //   links: [hasPermission(['leeds.show']) && leadsLinks, hasPermission(['general_forms.show']) && generalFormsLinks].filter(Boolean) as (IMenuLinks | ISingleMenuLinks)[]
    // },
    {
      name: t('links.locations'),
      icon: [locationIcon],
      keyName: 'locationsGroupLinks',
      links: [
        hasPermission(['locations.edit']) && locationsLinks,
        hasPermission(['locations.edit']) && citiesLinks,
        hasPermission(['locations.edit']) && deliveryOptionsLinks
      ].filter(Boolean) as (IMenuLinks | ISingleMenuLinks)[]
    },
    {
      name: t('orders'),
      icon: [bodyTypeIcon],
      keyName: 'ordersGroupLinks',
      links: [
        hasPermission(['orders.show', 'orders.edit']) && ordersLinks,
        hasPermission(['order_steps.show', 'order_steps.edit']) && orderStepsLinks,
        hasPermission(['orders.show']) && financingApplicationsLinks
        // financingApplicationsLinks
      ].filter(Boolean) as (IMenuLinks | ISingleMenuLinks)[]
    }
    // {
    //   name: t('links.financing'),
    //   icon: [bodyTypeIcon],
    //   keyName: 'financingGroupLinks',
    //   links: [
    //     hasPermission(['applications.get']) && findDealLinks,
    //     hasPermission(['service_providers.show', 'service_providers.crud']) && serviceProviderLinks,
    //     quotationsLinks,
    //     hasPermission(['products.show', 'products.edit']) && productLinks,
    //     hasPermission(['distributors.show', 'distributors.edit']) && distributorsLinks,
    //     hasPermission(['users.show', 'users.edit']) && salesLinks,
    //     hasPermission(['applications.get']) && applicationsLinks
    //   ].filter(Boolean) as (IMenuLinks | ISingleMenuLinks)[]
    // }
  ].filter((ele) => ele.links.length > 0);

  const [expanded, setExpanded] = useState<string>('');

  return (
    <ul className="nav_links">
      <ActiveSideMenuAccordionContextProvider>
        <SingleNavLinks links={dashboardLinks} />

        {menuGroups.map((group, index) => (
          <NavLinksGroup
            isMouseOver={isMouseOver}
            key={index}
            icon={group.icon}
            name={group.name}
            links={group.links}
            keyName={group.keyName}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}

        {hasPermission(['admins.show', 'admins.edit']) && (
          <TogglerNavLink isMouseOver={isMouseOver} key={'adminsLinks'} links={adminsLinks as IMenuLinks} expanded={expanded} setExpanded={setExpanded} />
        )}
        {hasPermission(['roles.show', 'roles.edit']) && (
          <TogglerNavLink isMouseOver={isMouseOver} key={'rolesLinks'} links={rolesLinks as IMenuLinks} expanded={expanded} setExpanded={setExpanded} />
        )}
        {/* {(
          <TogglerNavLink isMouseOver={isMouseOver} key={'generalFormsLinks'} links={generalFormsLinks as IMenuLinks} expanded={expanded} setExpanded={setExpanded} />
        )} */}

        {hasPermission(['terms_and_conditions.edit']) && (
          <TogglerNavLink isMouseOver={isMouseOver} key={'termsAndConditionsLinks'} links={termsAndConditionsLinks as IMenuLinks} expanded={expanded} setExpanded={setExpanded} />
        )}

        {hasPermission(['terms_and_conditions.edit']) && (
          <TogglerNavLink isMouseOver={isMouseOver} key={'faqs'} links={faqs as IMenuLinks} expanded={expanded} setExpanded={setExpanded} />
        )}
      </ActiveSideMenuAccordionContextProvider>
    </ul>
  );
};

export default SideMenuLinks;
